import { useAtom } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';
import { accountSummaryV2CacheKey, queryFnFactory } from '@syf-api-library/account-summary';
import { apiConfigAtom } from './accountActivity';
export const accountSummaryAtom = atomWithQuery((get) => {
    const apiConfig = get(apiConfigAtom);
    return {
        queryKey: accountSummaryV2CacheKey(apiConfig.keyProps),
        queryFn: queryFnFactory(apiConfig.config, apiConfig.keyProps),
        queryOptions: Object.assign({}, apiConfig.queryOptions)
    };
});
export const useAccountSummary = () => {
    return useAtom(accountSummaryAtom);
};
